import { createVanIconComponent } from "./van"

const BarChartOutlined = createVanIconComponent("bar-chart-o")
export default BarChartOutlined
